import React from "react";
import { Box } from "@material-ui/core";

import SearchedTicketsList from "../../components/SearchedTicketsList";
import TicketsList from "../../components/TicketsList";

/**
 * Painéis de lista por aba — só monta a aba ativa (evita sockets/API duplicados).
 */
export default function TailwickTicketListPanels({
	tab,
	searched,
	searchParam,
	showAllTickets,
	showUnread,
	selectedQueueIds,
	selectedTagIds,
	sortOrder,
	setStatusCount,
	setSearchLoading,
	applyPanelStyle,
	statusPerfilEnabled = false,
	selectedChannels,
	bulkSelection,
	setBulkSelection,
	bulkSelected = [],
	setBulkSelected
}) {
	// A busca procura em todos os status, então o resultado vale para qualquer aba.
	if (searched !== 0) {
		return (
			<div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
				<SearchedTicketsList
					searchParam={searchParam}
					showAll={showAllTickets}
					showUnread={showUnread}
					selectedQueueIds={selectedQueueIds}
					channels={selectedChannels}
					searched={searched}
					setSearchLoading={setSearchLoading}
					tags={selectedTagIds}
					tailwickLayout
					bulkSelection={bulkSelection}
					bulkSelected={bulkSelected}
				/>
			</div>
		);
	}

	return (
		<>
			{tab === "open" && (
				<div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
					<TicketsList
						status="open"
						showAll={showAllTickets}
						showUnread={showUnread}
						selectedQueueIds={selectedQueueIds}
						channels={selectedChannels}
						sortBy={sortOrder.sortByOpen}
						style={applyPanelStyle("open")}
						tags={selectedTagIds}
						tailwickLayout
						bulkSelection={bulkSelection}
						setBulkSelection={setBulkSelection}
						bulkSelected={bulkSelected}
						setBulkSelected={setBulkSelected}
					/>
				</div>
			)}

			{tab === "pending" && (
				<div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
					<TicketsList
						status="pending"
						showAll
						sortBy={sortOrder.sortByPending}
						selectedQueueIds={selectedQueueIds}
						channels={selectedChannels}
						tags={selectedTagIds}
						tailwickLayout
						bulkSelection={bulkSelection}
						setBulkSelection={setBulkSelection}
						bulkSelected={bulkSelected}
						setBulkSelected={setBulkSelected}
					/>
				</div>
			)}

			{statusPerfilEnabled && tab === "status" && (
				<div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
					<TicketsList
						status="status"
						showAll
						sortBy={sortOrder.sortByPending}
						selectedQueueIds={selectedQueueIds}
						channels={selectedChannels}
						updateCount={(val) => setStatusCount(val)}
						tags={selectedTagIds}
						tailwickLayout
						statusPerfilEnabled
						bulkSelection={bulkSelection}
						setBulkSelection={setBulkSelection}
						bulkSelected={bulkSelected}
						setBulkSelected={setBulkSelected}
					/>
				</div>
			)}

			{tab === "closed" && (
				<div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
					<TicketsList
						status="closed"
						showAll
						sortBy={sortOrder.sortByClosed}
						selectedQueueIds={selectedQueueIds}
						tags={selectedTagIds}
						tailwickLayout
						channels={selectedChannels}
						bulkSelection={bulkSelection}
						setBulkSelection={setBulkSelection}
						bulkSelected={bulkSelected}
						setBulkSelected={setBulkSelected}
					/>
				</div>
			)}
		</>
	);
}

/** Painéis legados — monta só a aba visível. */
export function LegacyTicketListPanels(props) {
	const {
		tab,
		searched,
		searchParam,
		showAllTickets,
		showUnread,
		selectedQueueIds,
		selectedTagIds,
		sortOrder,
		setStatusCount,
		setSearchLoading,
		applyPanelStyle,
		selectedChannels,
	} = props;

	const statusPerfilEnabled = props.statusPerfilEnabled ?? false;

	if (searched !== 0) {
		return (
			<Box height="100%">
				<SearchedTicketsList
					searchParam={searchParam}
					showAll={showAllTickets}
					showUnread={showUnread}
					selectedQueueIds={selectedQueueIds}
					searched={searched}
					setSearchLoading={setSearchLoading}
					tags={selectedTagIds}
					channels={selectedChannels}
				/>
			</Box>
		);
	}

	return (
		<>
			{tab === "open" && (
				<Box height="100%">
					<TicketsList
						status="open"
						showAll={showAllTickets}
						showUnread={showUnread}
						selectedQueueIds={selectedQueueIds}
						sortBy={sortOrder.sortByOpen}
						style={applyPanelStyle("open")}
						tags={selectedTagIds}
						channels={selectedChannels}
					/>
				</Box>
			)}

			{tab === "pending" && (
				<Box height="100%">
					<TicketsList
						status="pending"
						showAll
						sortBy={sortOrder.sortByPending}
						selectedQueueIds={selectedQueueIds}
						tags={selectedTagIds}
						channels={selectedChannels}
					/>
				</Box>
			)}

			{statusPerfilEnabled && tab === "status" && (
				<Box height="100%">
					<TicketsList
						status="status"
						showAll
						sortBy={sortOrder.sortByPending}
						selectedQueueIds={selectedQueueIds}
						updateCount={(val) => setStatusCount(val)}
						tags={selectedTagIds}
						channels={selectedChannels}
					/>
				</Box>
			)}

			{tab === "closed" && (
				<Box height="100%">
					<TicketsList
						status="closed"
						showAll
						sortBy={sortOrder.sortByClosed}
						selectedQueueIds={selectedQueueIds}
						tags={selectedTagIds}
						channels={selectedChannels}
					/>
				</Box>
			)}
		</>
	);
}
